import { getCountryNameByCountryCode, getStatusDescriptionFromStatusValue, getOrderTypeText } from '../../../../../utils/utility';
import { getDateWithSpecificFormat } from '../../../../data-transform';


export default function quoteDetailsTableColumns(config) {
    let result = {};
    let tableData = [];

    const { quoteDetailsRow = [], userType, customerType } = config.data;

    const isCustomer = userType === "legal_entity" || userType === "Customer" || userType === "regional" || userType === "master";
    quoteDetailsRow.forEach(quoteDetailsDRS => {
        let row = [];
        const rowId = quoteDetailsDRS.quoteId;
        config.columns.forEach(column => {
            let columnValue = "";
            let linkDestination = "";

            let displayAsIs = column.data.displayInBodyAsIs;
            if (column.data.displayInBodyAs === "string") {
                if (column.id === "quoteNumber") {
                    columnValue = quoteDetailsDRS.quoteId || "";
                    displayAsIs = true;
                }
                if (column.id === "quoteCreationDate") {
                    columnValue = getDateWithSpecificFormat(quoteDetailsDRS.createdDate) || "";
                    displayAsIs = true;
                }
                if (column.id === "orderType") {
                    columnValue = getOrderTypeText(quoteDetailsDRS.orderType) || "";
                    displayAsIs = true;
                }
                if (column.id === "country") {
                    columnValue = getCountryNameByCountryCode(quoteDetailsDRS.countryCode) || "";
                    displayAsIs = true;
                }
                if (column.id === "legalEntityName") {
                    columnValue = quoteDetailsDRS.legalEntity || "";
                    displayAsIs = true;
                }
                if (column.id === "collectionCity") {
                    columnValue = quoteDetailsDRS.shippingAddress && quoteDetailsDRS.shippingAddress.city ? quoteDetailsDRS.shippingAddress.city : "-";
                    displayAsIs = true;
                }
                if (column.id === "status") {
                    if (isCustomer && quoteDetailsDRS.status === 'PENDING_HP_REVIEW') {
                        columnValue = getStatusDescriptionFromStatusValue('PENDING_PRICES')
                    } else {
                        columnValue = getStatusDescriptionFromStatusValue(quoteDetailsDRS.status) || "";
                    }
                    displayAsIs = true;
                }
                if (column.id === "priceUploadedDate") {
                    columnValue = getDateWithSpecificFormat(quoteDetailsDRS.priceUploadedDate) || "";
                    displayAsIs = true;
                }
                if (column.id === "qtyOfAssets") {
                    columnValue = quoteDetailsDRS.totalDevicesQuoted;
                    displayAsIs = true;
                }
                if (column.id === "currency") {
                    columnValue = quoteDetailsDRS.currencyCode || "";
                    displayAsIs = true;
                }
                else if (column.id === "quotedNetValue") {
                    if(customerType === 'indirect') {
                        columnValue = quoteDetailsDRS?.netValue?.toFixed(2);
                    } else {
                        columnValue = isCustomer ? quoteDetailsDRS?.cnetValue?.toFixed(2) : quoteDetailsDRS?.vnetValue?.toFixed(2);
                    }
                    
                    if (quoteDetailsDRS.status === 'PENDING_PRICES') {
                        columnValue = '';
                    }
                    displayAsIs = true;
                }
                else if (column.id === "quotedHWBuybackValue") {
                    if (quoteDetailsDRS.status === 'PENDING_PRICES') {
                        columnValue = '';
                    } else {
                        columnValue = isCustomer ?
                            quoteDetailsDRS?.chwBuyBackValue?.toFixed(2) :
                            quoteDetailsDRS.vhwBuyBackValue ? quoteDetailsDRS?.vhwBuyBackValue?.toFixed(2) : quoteDetailsDRS?.vhwBuyBackValue?.toFixed(2);
                    }
                    displayAsIs = true;
                }
                else if (column.id === "quotedServiceCost") {
                    if (quoteDetailsDRS.status === 'PENDING_PRICES') {
                        columnValue = '';
                    } else {
                        columnValue = isCustomer ? quoteDetailsDRS?.cserviceCost?.toFixed(2) : quoteDetailsDRS?.vserviceCost?.toFixed(2);
                    }
                    displayAsIs = true;
                }                
                else if (column.id === "vendorQuotedNetValueVendor") {
                    columnValue = quoteDetailsDRS.vnetValue !== null ? quoteDetailsDRS.vnetValue : "";
                }
                else if (column.id === "vendorQuotedHWBuybackValueVendor") {
                    columnValue = quoteDetailsDRS.vhwBuyBackValue !== null ? quoteDetailsDRS.vhwBuyBackValue : "";
                }
                else if (column.id === "vendorQuotedServiceCostsVendor") {
                    columnValue = quoteDetailsDRS.vserviceCost !== null ? quoteDetailsDRS.vserviceCost : "";
                }
                if (column.id === "vendorQuotedRevitalizeFees") {
                    columnValue = quoteDetailsDRS?.vhardwareRevitalizeFees?.toFixed(2) || "";
                    displayAsIs = true;
                }
            }

            row.push({
                [column.id]: {
                    id: column.id + "|" + rowId,
                    type: column.data.displayInBodyAs,
                    value: columnValue,
                    width: column.width,
                    displayAsIs: displayAsIs,
                    linkDestination: linkDestination,
                    showInMobileViewAs: column.showInMobileViewAs
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    });


    result['columns'] = config.columns;
    result['data'] = tableData;

    return result;
}